import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
  import { useStore } from 'vuex';
  import { vibrate } from '../utils/vibrate';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TrackEqualizer',
  setup(__props, { expose }) {
  expose();

  const hidden = ref(false);
  const volumeLevel = ref(10);
  const balance = ref(0);
  
  const gains = ref(['0', '0', '0', '0', '0', '0']);
  const store = useStore();

  const getShowEqualizer = () => {
    return store.getters.showEqualizer;
  };
  
  const updateVolume = (newVolumeLevel: string): void => {
    vibrate();
    store.commit('refreshVolume', parseFloat(newVolumeLevel));
  }
  
  const updateBalance = (newBalance: string): void => {
    vibrate();
    store.commit('refreshBalance', parseFloat(newBalance));
  };
  
  const updateGains = (index: number): void => {
    vibrate();
    store.commit('refreshGain', { 'newValue': parseFloat(gains.value[index]), 'index': index });
  };

  store.subscribe((mutation, state) => {
    if (mutation.type === 'refreshShowEqualizer') {
      hidden.value = getShowEqualizer();
    }
  });

const __returned__ = { hidden, volumeLevel, balance, gains, store, getShowEqualizer, updateVolume, updateBalance, updateGains }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})